import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InputProps, Label } from "reactstrap";
import Select from "react-select";

import { TemplateDto } from "../../interfaces";
import { useGetTemplatesQuery } from "../../store/api/templateApi";

type TProps = InputProps & {
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  value: any;
  onChange: (values: any) => void;
  placeholder: string;
};

export const TemplateSelect: React.FC<TProps> = ({
  onChange,
  value,
  closeMenuOnSelect = true,
  isMulti = false,
  placeholder,
}) => {
  const { t, i18n } = useTranslation();

  const { data, error, isSuccess } = useGetTemplatesQuery();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    if (error) {
      const errMsg =
        "status" in error
          ? (error.data as any)?.message || "An error occurred"
          : "An error occurred";
      toast.error(errMsg, {
        autoClose: 3000,
      });
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess && data) {
      var mappedOptions = data?.map((item: TemplateDto) => {
        return {
          label: item.friendlyName,
          value: item.sid,
        };
      });
      setOptions(mappedOptions);
    }
  }, [data, isSuccess, i18n.language]);

  return (
    <>
      <p>
        <a
          href="https://console.twilio.com/us1/develop/sms/content-template-builder"
          target="_blank"
          rel="noreferrer"
          className="link"
          style={{ cursor: "pointer" }}
        >
          <i className="ri-link align-bottom me-1"></i>
          {t("manageTemplates")}
        </a>
      </p>
      <Label htmlFor="template" className="form-label">
        {t("template")}
        <span className="text-danger">*</span>
      </Label>
      <Select
        placeholder={t(placeholder)}
        closeMenuOnSelect={closeMenuOnSelect}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        options={options}
      />
    </>
  );
};
